import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { publish, subscribe, unsubscribe } from '../../../utils/events';
import OldWagers from './OldWagers/OldWagers';

const EVENT_NAME = 'KAMBI_SPORTSBOOK:SHOW_MODAL_PAIRPLAY';

// Flag global para rastrear si el modal ya está siendo mostrado
let isModalOpen = false;

export const openModalPariplay = () => {
  return new Promise(resolve => {
    publish(EVENT_NAME, { resolve });
  });
};

export const ModalOldWagersPariplay = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const listener = event => {
      // Solo procesar el evento si el modal no está abierto globalmente
      if (isModalOpen) {
        return;
      }

      isModalOpen = true;
      setIsOpen(true);
    };

    subscribe(EVENT_NAME, listener);

    return () => {
      unsubscribe(EVENT_NAME, listener);
      isModalOpen = false;
    };
  }, []);

  const closePanel = () => {
    setIsOpen(false);
    isModalOpen = false;
  };

  if (!isOpen) return null;

  return (
    <Modal show={true} className="absoluteModal" dialogClassName="modal-dialog-sm" >
      <div>
        <div id="panelTitle" className="panel-abonar-titulo">
          <span>Historial Apuestas Pasadas</span>
          <button className="cerrar-panel" onClick={closePanel}>
            <div className="btn-icon-close">
              <i className="ion-ios-close-empty" />
            </div>
          </button>
        </div>
      </div>
      <OldWagers />
    </Modal>
  );
};
